import { render, staticRenderFns } from "./viewUnionLocations.vue?vue&type=template&id=3473974a&scoped=true&"
import script from "./viewUnionLocations.vue?vue&type=script&lang=js&"
export * from "./viewUnionLocations.vue?vue&type=script&lang=js&"
import style0 from "./viewUnionLocations.vue?vue&type=style&index=0&id=3473974a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3473974a",
  null
  
)

export default component.exports